import Service from '@/services/Service'
import { formataDataBD } from '@/utils/utils'

class ParcelService extends Service {
  constructor() {
    super('PARCELS')
    this.resource = 'parcels'
  }

  translateToFirebird(obj) {
    let objFirebird = {
      FASE: obj.faseObra,
      SEQ: obj.index,
      DATA: formataDataBD(obj.data),
      VENCIMENTO:
        obj.vencimento == 'A VISTA'
          ? formataDataBD(obj.data)
          : formataDataBD(obj.vencimento),
      CONDICAOPGTO: { CODIGO: obj.codigoCondicao },
      CONDICAO: obj.condicao,
      CONTA: obj.conta ? { CODIGO: obj.conta.CODIGO } : null,
      CT: obj.ct,
      VALOR: obj.valor,
      ACRESCIMOFINANCEIRO: obj.valorAcrescimoFinanceiro,
      INFORMOUVALOR: obj.informouValor,
    }
    return objFirebird
  }

  translateFromFirebird(obj) {
    console.log(obj)
  }

  async getParcel(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    let data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }

  async getParcels(query = null) {
    if (query) {
      let requestUrl = `${this.resource}?`

      query = this.encodeQueryValues(query)

      if (query.codigo && query.codigo.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CODIGO=${query.codigo}`
          : `CODIGO=${query.codigo}`
      } else if (query.descricao && query.descricao.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&DESCRICAO=${query.descricao}`
          : `DESCRICAO=${query.descricao}`
      } else if (query.ct && query.ct.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CT=${query.ct}`
          : `CT=${query.ct}`
      } else if (query.codigoConta && query.codigoConta.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CONTA=${query.conta}`
          : `CONTA=${query.conta}`
      }

      if (query.todos)
        requestUrl += this.hasParameter(requestUrl)
          ? `&TODOS=${query.todos}`
          : `TODOS=${query.todos}`
      else
        requestUrl += this.hasParameter(requestUrl)
          ? `&page=${query.page}`
          : `page=${query.page}`

      return await this.getAPI(requestUrl)
    } else {
      return Promise.reject('Ocorreu um erro')
    }
  }
}

export default new ParcelService()
